import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import block from 'bem-cn';
import SVG from 'components/SVG';
import crossSVG from './img/cross.svg';
import { customRequestTypesEnums } from 'features/creativeFunctionality/models/customRequestsModel/data';

import ProvidersDetails from './Pages/ProvidersDetails/ProvidersDetails';
import GamesDetails from './Pages/GamesDetails/GamesDetails';
import NotificationDetails from './Pages/NotificationDetails/NotificationDetails';
import SocialMediaDetails from './Pages/SocialMediaDetails/SocialMediaDetails';

import './CustomRequestDetails.scss';

const b = block('custom-request-details');

const CustomRequestDetails = ({ details, onClose }) => {
  const { type, providers, games } = details;
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const DetailsElement = useMemo(() => {
    switch (type) {
      case customRequestTypesEnums.providers:
        return <ProvidersDetails providers={providers} />;
      case customRequestTypesEnums.game:
        return <GamesDetails games={games} />;
      case customRequestTypesEnums.socialMedia:
        return <SocialMediaDetails />;
      case customRequestTypesEnums.notifications:
        return <NotificationDetails />;
      default:
        return null;
    }
  }, [details]);

  const detailsHeaderText = useMemo(() => {
    switch (type) {
      case customRequestTypesEnums.providers:
        return locale.providersDetails;
      case customRequestTypesEnums.game:
        return locale.gamesDetails;
      case customRequestTypesEnums.socialMedia:
        return locale.requestForChangeOfSocialMedia;
      case customRequestTypesEnums.notifications:
        return locale.requestForChangeOfNotifications;
      default:
        return null;
    }
  }, [type, locale]);

  return (
    <div className={b()}>
      <div className={b('header')}>
        {detailsHeaderText}
        <SVG svgProps={{ svg: crossSVG }} className={b('header-cross')} onClick={onClose} />
      </div>
      <div className={b('content')}>{DetailsElement}</div>
    </div>
  );
};

export default CustomRequestDetails;
